"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var lodash_1 = require("lodash");
var qs_1 = require("qs");
var react_tracking_1 = require("react-tracking");
var elog = require("../../elog");
var bind_1 = require("../../bind");
var overflowing_row_1 = require("../../components/overflowing_row");
var tiles_1 = require("../../components/tiles");
var tracker_1 = require("../../tracker");
var core_link_1 = require("../../components/core_link");
var sanitized_render_1 = require("../../components/sanitized_render");
var COMPONENT_NAME = 'CategoryCollection';
var CategoryCollection = /** @class */ (function (_super) {
    tslib_1.__extends(CategoryCollection, _super);
    function CategoryCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CategoryCollection.prototype.queryString = function (cat) {
        if (cat.rootSlug) {
            return qs_1.stringify({ product_type: cat.rootSlug, category: cat.slug });
        }
        return qs_1.stringify({ product_type: cat.slug });
    };
    CategoryCollection.prototype.getLink = function (cat) {
        if (this.props.linkOverride) {
            if (this.queryString(cat)) {
                return this.props.linkOverride + "?" + this.queryString(cat);
            }
            return this.props.linkOverride;
        }
        return cat.cmsLink.href;
    };
    CategoryCollection.prototype.isEmpty = function () {
        return !this.props.data.loading && !lodash_1.get(this.props.data.categories, 'length');
    };
    CategoryCollection.prototype.isLoading = function () {
        return this.props.data.loading;
    };
    CategoryCollection.prototype.getBackgroundImageStyle = function (cat) {
        var src = lodash_1.get(cat.images[0], 'source');
        if (!src)
            return null;
        return { backgroundImage: "url(" + src + ")" };
    };
    CategoryCollection.prototype.renderTile = function (cat, idx) {
        return (React.createElement(core_link_1.default, { to: this.getLink(cat), className: "category-collection__item", style: this.getBackgroundImageStyle(cat), key: idx },
            React.createElement("div", { className: "category-collection__item__inner" },
                React.createElement("div", { className: "category-collection__item__text" }, cat.name))));
    };
    CategoryCollection.prototype.renderPlaceholder = function () {
        return (React.createElement("div", { className: "category-collection__item category-collection__item--placeholder" }));
    };
    CategoryCollection.prototype.renderTitle = function () {
        return (React.createElement(sanitized_render_1.default, { html: this.props.titleHtml || this.props.title }));
    };
    CategoryCollection.prototype.render = function () {
        try {
            if (this.isEmpty())
                return null;
            var categories = this.props.data.categories;
            return (React.createElement(overflowing_row_1.default, { collectionCount: categories && categories.length, title: this.renderTitle(), subtitleHtml: this.props.subtitleHtml, ledeHtml: this.props.ledeHtml, id: this.props.jumplinkSlug },
                React.createElement(tiles_1.default, { largeTiles: true, loading: this.isLoading(), placeholder: this.renderPlaceholder(), expectedCount: lodash_1.get(this.props.categoryUUIDs, 'length'), singleRow: true }, categories && categories.map(this.renderTile))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    tslib_1.__decorate([
        bind_1.default
    ], CategoryCollection.prototype, "renderTile", null);
    CategoryCollection = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                type: tracker_1.CATEGORY_TYPE,
                context: {
                    categoryUUIds: props.categoryUUIDs,
                    linkOverride: props.linkOverride,
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                }
            };
        })
    ], CategoryCollection);
    return CategoryCollection;
}(React.Component));
exports.CategoryCollection = CategoryCollection;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query Commons_Cms_CategoryCollection(\n    $categoryUuids: [String]\n  ) {\n    categories(input:{\n      ids: $categoryUuids\n    }) {\n      id\n      name\n      slug\n      rootSlug\n      cmsLink {\n        href\n      }\n      images(input:{\n        type:\"Category\",\n        count:1,\n        transform:\"card_wide\",\n        scope:\"full_bleed_brand\"\n      }) {\n        source\n      }\n    }\n  }\n  "], ["\n  query Commons_Cms_CategoryCollection(\n    $categoryUuids: [String]\n  ) {\n    categories(input:{\n      ids: $categoryUuids\n    }) {\n      id\n      name\n      slug\n      rootSlug\n      cmsLink {\n        href\n      }\n      images(input:{\n        type:\"Category\",\n        count:1,\n        transform:\"card_wide\",\n        scope:\"full_bleed_brand\"\n      }) {\n        source\n      }\n    }\n  }\n  "]))), {
    options: function (ownProps) { return ({
        ssr: ownProps.ssr,
        variables: {
            categoryUuids: ownProps.categoryUUIDs,
        },
    }); },
});
exports.default = connect(CategoryCollection);
var templateObject_1;
//# sourceMappingURL=category_collection.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/category_collection.js
// module id = D/hH
// module chunks = 0 2 6 20